import Box from "@mui/material/Box";
import axios from "axios";
import React, {
  ChangeEvent,
  useCallback,
  useRef,
  useState,
  useEffect,
} from "react";
import "./FileDragDrop.css";
import { Button, Grid, Paper } from "@mui/material"



interface IFileTypes {
  id: number;
  object: File;
}

const DragDrop = () => {
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [files, setFiles] = useState<IFileTypes[]>([]);

  const dragRef = useRef<HTMLLabelElement | null>(null);
  const fileId = useRef<number>(0);

  const fileUpload = async () => {
    if (files.length === 0) {
      alert("업로드할 파일을 선택해주세요.");
      return;
    }
    const formData = new FormData();
    // 선택한 파일들을 formData에 추가
    files.forEach((file) => {
      formData.append("files", file.object);
    });

    try {
      const result = await axios.post("http://localhost:9680/upload", formData, {
        withCredentials: true,
      });
      console.log("file upload ", result);
      alert("파일 업로드가 완료되었습니다.");

      
      setFiles([]);
    } catch (error:any) {
      console.error('에러',error.response);
      alert("파일 업로드 실패. " + error.response.data.error);
    }
  };

  const onChangeFiles = useCallback(
    (e: ChangeEvent<HTMLInputElement> | any): void => {
      let selectFiles: File[] = [];
      let tempFiles: IFileTypes[] = files;
  
      if (e.type === "drop") {
        selectFiles = e.dataTransfer.files;
      } else {
        selectFiles = e.target.files;
      }
  
      for (const file of selectFiles) {
        const extension = file.name.split(".").pop();
  
        // 파일업로드 확장자 통과목록

        // if (extension === "mp3" || extension === "wav" || extension === "ogg" || extension === "m4a" || extension === "M4A") {

        const isDuplicate = tempFiles.some(
          (tempFile) =>
            tempFile.object.name === file.name
        );
        if (isDuplicate) {
          alert(`${file.name} 파일은 이미 추가되었습니다.`);
        } else if (
          extension === "mp3" ||
          extension === "wav" ||
          extension === "ogg"
        ) {
        tempFiles = [
          ...tempFiles,
          {
            id: fileId.current++,
            object: file,
          },
        ];
        } else {
          alert("오디오 파일만 업로드 가능합니다.");
        }
      }
      console.log("tempFiles", tempFiles);
      setFiles(tempFiles);
    },
    [files]
  );
  
  const handleFilterFile = useCallback(
    (id: number): void => {
      setFiles(files.filter((file: IFileTypes) => file.id !== id));
    },
    [files]
  );

  const handleDragIn = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragOut = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer!.files && e.dataTransfer!.files.length > 0) {
      const extension = e.dataTransfer!.files[0].name.split(".").pop();
      if (extension === "mp3" || extension === "wav" || extension === "ogg") {
        setIsDragging(true);
      } else {
        setIsDragging(false);
      }
    }
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent): void => {
      e.preventDefault();
      e.stopPropagation();

      onChangeFiles(e);
      setIsDragging(false);
    },
    [onChangeFiles]
  );

  const initDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.addEventListener("dragenter", handleDragIn);
      dragRef.current.addEventListener("dragleave", handleDragOut);
      dragRef.current.addEventListener("dragover", handleDragOver);
      dragRef.current.addEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  const resetDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.removeEventListener("dragenter", handleDragIn);
      dragRef.current.removeEventListener("dragleave", handleDragOut);
      dragRef.current.removeEventListener("dragover", handleDragOver);
      dragRef.current.removeEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  useEffect(() => {
    initDragEvents();

    return () => resetDragEvents();
  }, [initDragEvents, resetDragEvents]);

  return (
    <Box sx={{ width: "400px", textAlign: "center" }}>
      <Grid container>
        <Paper elevation={3} sx={{margin:'auto'}}>
          <Box sx={{display: "flex", justifyContent: "center", width: "400px"}}>
            <Box sx={{display: "flex"}}>
              <img style={{width:"34px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/insight_logo2.png'} />
            </Box>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:600, fontSize: "large", alignSelf: "center"}}>INSIGHT HUB</Box>  
          </Box>
          <div className="DragDrop">
            <input
              type="file"
              id="fileUpload"
              style={{ display: "none" }}
              multiple={true}
              onChange={onChangeFiles}
            />

            <label
              className={isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}
              htmlFor="fileUpload"
              ref={dragRef}
            >
              <div>파일 첨부</div>
            </label>
            <Button onClick={fileUpload}>파일 전송</Button>
            <div className="DragDrop-Files">
              {files.length > 0 &&
                files.map((file: IFileTypes) => {
                  const {
                    id,
                    object: { name },
                  } = file;

                  return (
                    <div key={id}>
                      <div>{name}</div>
                      <div
                        className="DragDrop-Files-Filter"
                        onClick={() => handleFilterFile(id)}
                      >
                        X
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          </Paper>
        </Grid>
      </Box>
  );
};

export default DragDrop;
